<template>
  <div id="app">
    <Calc/>
    <br>
    <hr>
    <b-container>
      TODO: footer, contact, license
    </b-container>
  </div>
</template>

<script>
import Calc from './components/Calc'

export default {
  name: 'App',
  components: {
    Calc
  }
}
</script>

<style>
body {
  background-color: #000 !important;
  color: #ddd !important;
}
hr {
  border-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue